import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';


const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  VIEW_USER: 'user_view',
  ADD_USER: 'user_add',
  CHANGE_USER: 'user_change',
  DELETE_USER: 'user_delete',
  VIEW_ROLE: 'role_view',
  CHANGE_ROLE: 'role_change',
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.VIEW_USER,
    PERMISSIONS.ADD_USER,
    PERMISSIONS.CHANGE_USER,
    PERMISSIONS.DELETE_USER,
    PERMISSIONS.VIEW_ROLE,
    PERMISSIONS.CHANGE_ROLE,
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.VIEW_USER,
    PERMISSIONS.VIEW_ROLE,
  ],
  [ROLES.LOGISTICS_COORDINATOR]: [
    PERMISSIONS.CHANGE_USER,
    PERMISSIONS.VIEW_ROLE,
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.CHANGE_USER,
    PERMISSIONS.VIEW_ROLE,
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_USER,
    PERMISSIONS.VIEW_ROLE,
  ],
};


const usePermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  const can = {
    viewUser: () => hasPermission(PERMISSIONS.VIEW_USER),
    addUser: () => hasPermission(PERMISSIONS.ADD_USER),
    editUser: () => hasPermission(PERMISSIONS.CHANGE_USER),
    deleteUser: () => hasPermission(PERMISSIONS.DELETE_USER),
    viewRole: () => hasPermission(PERMISSIONS.VIEW_ROLE),
    changeRole: () => hasPermission(PERMISSIONS.CHANGE_ROLE),
  };

  return {
    loading,
    error,
    can,
    ROLES,
    PERMISSIONS
  };
};

export default usePermissions;